export default {"src":"/_next/static/media/@facebook.7dcebdd7.svg","height":30,"width":30};